import { useSearchParams } from 'react-router';

export const OPENER_SOURCE_SEARCH_PARAM = 'source';

export function useOpenerSource() {
  const [params] = useSearchParams();

  return {
    openerSource: params.get(OPENER_SOURCE_SEARCH_PARAM) || 'sdk',
  };
}
